import { render, staticRenderFns } from "./KintaiCardLabelValueItem.vue?vue&type=template&id=101cfb39&scoped=true&"
import script from "./KintaiCardLabelValueItem.vue?vue&type=script&lang=ts&"
export * from "./KintaiCardLabelValueItem.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiCardLabelValueItem.vue?vue&type=style&index=0&id=101cfb39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101cfb39",
  null
  
)

export default component.exports